module.exports = __webpack_public_path__ + "static/img/logo2.606ad025.png";